__turbopack_context__.v({
  "signUpComponent": "signUp-module-scss-module__z0gV8G__signUpComponent",
});
